import type {
    PrincipalTeacherDto,
    StudentDto,
    TeacherDto,
    UserDto,
} from "@/entities/user/models/dtos";
import { UserType } from "@/entities/user/models/enums";
import { singleton } from "tsyringe";

export interface UserBehaviorStructure {
    isPrincipal: (userDto: unknown) => userDto is PrincipalTeacherDto;
    isTeacher: (userDto: unknown) => userDto is TeacherDto;
    isAcademyIdExist: (userDto: PrincipalTeacherDto | TeacherDto) => string | null;
}

@singleton()
export class UserBehavior implements UserBehaviorStructure {
    public isPrincipal = (userDto: unknown): userDto is PrincipalTeacherDto => {
        return (
            userDto != null && (userDto as PrincipalTeacherDto).type === UserType.PrincipalTeacher
        );
    };

    public isStudent = (userDto: unknown): userDto is StudentDto => {
        return userDto != null && (userDto as StudentDto).type === UserType.Student;
    };

    public isTeacher = (userDto: unknown): userDto is TeacherDto => {
        return userDto != null && (userDto as TeacherDto).type === UserType.Teacher;
    };

    public isAcademyIdExist = (userDto: PrincipalTeacherDto | TeacherDto): string | null => {
        return userDto != null && userDto.academy?.id !== undefined ? userDto.academy.id : null;
    };

    public isUserDto = (data: unknown): data is UserDto => {
        return data != null && (data as UserDto).type !== undefined;
    };

    public mappingUserTypeInString = (user: UserDto) => {
        const map = {
            [UserType.FranchiseMaster]: "프랜차이즈 관리자",
            [UserType.Master]: "관리자",
            [UserType.PrincipalTeacher]: "원장님",
            [UserType.Teacher]: "선생님",
            [UserType.Student]: "학생",
        };

        return map[user.type];
    };
}
